import { useState } from "react";
import { TextPerformanceReport } from "../../../Reports/TextPerformance/TextPerformance";
import { IndividualTextPerformance } from "../../../Reports/TextPerformance/IndividualTextPerformance";
import { Grid } from "@mui/material";
import { useTextPerformanceReportState } from "../../../Reports/TextPerformance/TextPerformanceReportState";
import DateRangePicker from "../../../App/Components/DateRange/DateRangePicker";
import TextMetricCards from "../../../Reports/TextPerformance/TextMetricsCards";

export default function TextAnalytics({ groupId }: { groupId: string }) {
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());

  const textState = useTextPerformanceReportState(startDate, endDate, groupId);

  return (
    <>
      <Grid container sx={{ mb: 3, mt: 3 }}>
        <Grid item md={6} lg={9}></Grid>
        <Grid item xs={12} md={6} lg={3}>
          <DateRangePicker
            id="group-text-report-dates"
            startDate={startDate}
            endDate={endDate}
            handleSetStartDate={(d) => {
              if (d) setStartDate(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0));
            }}
            handleSetEndDate={(d) => {
              if (d) setEndDate(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59));
            }}
          />
        </Grid>
      </Grid>
      <TextMetricCards id="group" state={textState} />
      <TextPerformanceReport
        reportData={textState.getters.reportData}
        enabled={true}
        id="group"
        loading={textState.getters.isLoading}
      />
      <IndividualTextPerformance groupId={groupId} startDate={startDate} endDate={endDate} />
    </>
  );
}
